<script>
export default {
  name: "IconGreenWorkshopDocument"
};
</script>

<template>
  <svg width="14" height="19" viewBox="0 0 14 19" xmlns="http://www.w3.org/2000/svg">
    <g fill="currentColor" fill-rule="evenodd">
      <path
        d="M11.05 0L14 3.08V18.3a.7.7 0 01-.7.7H.7a.7.7 0 01-.7-.7V.7C0 .31.31 0 .7 0h10.36zm-.46 1.33H1.33v16.34h11.34V3.57h-1.38a.7.7 0 01-.7-.7V1.32z"
      />
      <path
        d="M10.4 6.14c.21 0 .38.17.38.4a.4.4 0 01-.3.38H5.11a.39.39 0 01-.38-.39c0-.19.13-.35.3-.39h5.38zM10.4 9.3c.21 0 .38.18.38.4a.4.4 0 01-.3.39H5.11a.39.39 0 01-.38-.4c0-.18.13-.34.3-.38h5.38zM10.4 12.47c.21 0 .38.18.38.4a.4.4 0 01-.3.38l-.07.01H5.1a.39.39 0 01-.38-.4c0-.19.13-.35.3-.38l.08-.01h5.3zM3.6 5.94c.3 0 .56.26.56.6 0 .28-.2.53-.46.58h-.48a.58.58 0 01-.57-.59c0-.29.2-.53.46-.58l.1-.01h.38zM3.6 9.1c.3 0 .56.27.56.6 0 .29-.2.53-.46.58l-.1.01h-.38a.58.58 0 01-.57-.6c0-.28.2-.53.46-.58h.48zM3.6 12.27c.3 0 .56.27.56.6 0 .29-.2.53-.46.58h-.48a.58.58 0 01-.57-.59c0-.29.2-.53.46-.58h.48z"
        fill-rule="nonzero"
      />
    </g>
  </svg>
</template>
